<template>
  <v-container class="container">
    <v-card>
      <v-card-title>Formulario de Pago a Vocales</v-card-title>

      <v-card-text>
        <v-divider class="mb-4" />

        <v-form ref="form" v-model="valid">
          <h5>Electorales</h5>
          <v-divider class="mb-4" />

          <v-row>
            <v-col cols="12" md="4">
              <v-select
                v-model="formPago.nombreeleccion"
                :items="elecciones"
                item-value="nombre_corto"
                item-text="nombre_completo"
                label="Elección"
                :rules="[required, max255]"
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-menu
                ref="fechaEleccion"
                v-model="formPago.dateEleccion"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formPago.fechaeleccion"
                    label="Fecha de participación"
                    append-icon="mdi-calendar"
                    :rules="[required, fechaRule]"
                    outlined
                    dense
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>

                <v-date-picker
                  v-model="formPago.fechaeleccion"
                  no-title
                  @input="formPago.dateEleccion = false"
                />
              </v-menu>
            </v-col>

            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="formPago.conceptopago"
                :items="conceptos"
                item-value="id"
                item-text="name"
                label="Concepto"
                :rules="[required, max255]"
                @change="conceptoOnChange"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="formPago.codigomesa"
                :rules="[max255]"
                label="Código mesa"
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-file-input
                v-model="formPago.evidenciaFiles"
                label="Evidencia"
                multiple
                outlined
                dense
                small-chips
                show-size
                truncate-length="25"
                :disabled="uploadingEvidencia"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="formPago.codigoregistro"
                :rules="[max255]"
                label="Código registro"
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="formPago.dvcodigoregistro"
                :rules="[max255]"
                label="DV código registro"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="formPago.numeroregion"
                :items="regiones"
                item-text="region"
                item-value="numeroregion"
                label="Región"
                :rules="[max255]"
                outlined
                dense
                clearable
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="formPago.nombrecomuna"
                :items="comunasFiltradas"
                item-text="nombrecomuna"
                item-value="nombrecomuna"
                label="Nombre comuna"
                :rules="[max255]"
                outlined
                dense
                clearable
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
            <v-select
                v-model="formPago.tipoeleccion"
                :items="tipoELeccion"
                label="Tipo de elección"
                :rules="[required,max255]"
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="formPago.identificacionlocal"
                :rules="[max255]"
                label="Identificación local"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <v-menu
                ref="fechaCapacitacion"
                v-model="formPago.dateCapacitacion"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formPago.fechacapacitacion"
                    label="Fecha capacitación"
                    append-icon="mdi-calendar"
                    :rules="[max255]"
                    outlined
                    dense
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>

                <v-date-picker
                  v-model="formPago.fechacapacitacion"
                  no-title
                  @input="formPago.dateCapacitacion = false"
                />
              </v-menu>
            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="formPago.codigocircunscripcion"
                :items="circunscripcionesFiltradas"
                item-text="codigocircunscripcion"
                item-value="codigocircunscripcion"
                label="Código circunscripción"
                :rules="[max255]"
                outlined
                dense
                clearable
                @change="onCircunscripcionChange"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="formPago.circunscripcionelectoral"
                :items="circunscripcionesFiltradas"
                item-text="circunscripcionelectoral"
                item-value="circunscripcionelectoral"
                label="Circunscripción electoral"
                :rules="[max255]"
                outlined
                dense
                clearable
                @change="onCircunscripcionElectoralChange"
              />
            </v-col>
          </v-row>

          <h5 class="mt-4">Datos del Vocal</h5>
          <v-divider class="mb-4" />

          <v-row>
            <v-col cols="12" md="6">
              <v-row class="flex-nowrap">
                <v-col cols="8">
                  <v-text-field
                    v-model="formPago.rut"
                    :rules="[required, rutRule]"
                    label="Rut"
                    type="text"
                    outlined
                    dense
                  />
                </v-col>

                <v-col>
                  <v-text-field
                    v-model="formPago.dv"
                    :rules="[required, dvRule]"
                    label="DV"
                    outlined
                    dense
                    @input="formPago.dv = formPago.dv ? String(formPago.dv).toUpperCase() : ''"
                  />
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="formPago.nombre"
                :rules="[required, max255]"
                label="Nombre"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="formPago.apellidopaterno"
                :rules="[required, max255]"
                label="Apellido paterno"
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="formPago.apellidomaterno"
                :rules="[required, max255]"
                label="Apellido materno"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="formPago.correo"
                :rules="[emailRule, max255]"
                label="Correo electrónico"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <h5 class="mt-4">Dirección del Vocal</h5>
          <v-divider class="mb-4" />

          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="formPago.codigocomuna"
                :items="comunas"
                label="Comuna"
                :rules="[max255]"
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-select
                v-model="formPago.tipocalle"
                :items="tipoDeCalle"
                label="Tipo de calle"
                :rules="[max255]"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="formPago.calle"
                :rules="[max255]"
                label="Nombre calle"
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                v-model="formPago.dirnumero"
                :rules="[max255]"
                label="Número"
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                v-model="formPago.direcciondepto"
                label="Oficina / depto"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <h5 class="mt-4">Cuenta del Vocal</h5>
          <v-divider class="mb-4" />

          <v-row>
                        <v-col cols="12" md="6">
              <v-select
                v-model="formPago.mediopago"
                :items="medioPagoOptions"
                label="Medio de pago"
                :rules="[max255]"
                outlined
                dense
                @change="mediopagoOnChange"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-select
                v-model="formPago.bancopagosbif"
                :items="tipoDeBancos"
                item-value="id"
                item-text="name"
                label="Seleccione banco"
                :rules="[required]"
                outlined
                dense
              />
            </v-col>

          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="formPago.numerocuentapago"
                :rules="[required, cuentaRule]"
                label="Número de cuenta"
                outlined
                type="text"
                dense
                @input="formPago.numerocuentapago = formPago.numerocuentapago ? String(formPago.numerocuentapago).replace(/[^0-9]/g, '').slice(0, 15) : ''"
              />
            </v-col>

            
            <v-col cols="12" md="6">
              <v-select
                v-model="formPago.tipocuentapago"
                :items="tipoDeCuentaPagos"
                label="Tipo de cuenta pago"
                :rules="[required, max255]"
                outlined
                dense
              />
            </v-col>

          </v-row>

          <v-row>
            <v-col cols="12" md="2">
              <v-text-field
                v-model="formPago.monedapago"
                label="Moneda de pago"
                :rules="[required, max255]"
                outlined
                readonly
                disabled
                dense
              />
            </v-col>

            <v-col cols="12" md="10">
              <v-text-field
                v-model="formPago.montopago"
                label="Monto a pagar"
                :rules="[required, montoRule]"
                outlined
                readonly
                disabled
                dense
              />
            </v-col>
          </v-row>

          <v-row class="mt-4">
            <v-col cols="12" md="6">
              <v-btn @click="clearData" class="mr-2">Borrar campos</v-btn>
            </v-col>

            <v-col cols="12" md="6" class="d-flex justify-end">
              <v-btn
                :disabled="!validFormBtn"
                color="primary"
                @click="sendPago"
              >
                Enviar pago
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import comunas from "../../util/comunas";
import { PagoVocalesService } from "../../util/Api/PagoVocales/calls";
import axios from "axios";
import { Loading } from "element-ui";
import Swal from "sweetalert2";
import { mapGetters } from "vuex";

export default {
  name: "PagoVocalesComponent",

  data() {
    return {
      valid: null,
      loadingInstance: null,
      uploadingEvidencia: false,

      required: (v) => v !== null && v !== undefined && String(v).trim() !== "" || "El campo es requerido",
      max255: (v) => !v || String(v).length <= 255 || "Hasta 255 caracteres",
      fechaRule: (v) => !v || /^\d{4}-\d{2}-\d{2}$/.test(v) || "Formato inválido. Use YYYY-MM-DD",
      rutRule: (v) => /^[0-9]+$/.test(String(v || "")) || "Debe ser un número entero",
      dvRule: (v) => !!v && String(v).trim().length === 1 || "Debe tener exactamente 1 carácter",
      emailRule: (v) => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "Ingrese un correo electrónico válido",
      cuentaRule: (v) => {
        const value = String(v || "").trim();
        return (/^[0-9]+$/.test(value) && value.length <= 15)
          || "Debe contener solo números y hasta 15 dígitos";
      },
      montoRule: (v) => !v || /^[0-9]+(\.[0-9]+)?$/.test(String(v)) || "Debe ser un monto válido",

      comunas: [],
      glosas: [],
      regiones: [],
      comunasFiltradas: [],
      circunscripcionesFiltradas: [],
      skipRegionWatch: false,
      skipComunaWatch: false,
      elecciones: [],
      tipoELeccion:[
          "PRESIDENCIAL",
          "SENADORES" ,
          "DIPUTADOS",
          "ALCALDES",
          "CONCEJALES",
          "CONCEJEROS",
          "PLEBISCITO",
          "GORE",
          "CONCEJERO CONSTITUCIONAL"
      ],

      tipoDeCalle: ["CALLE", "AVENIDA", "PASAJE"],

      conceptos: [
        { id: "SERVEL_PAGO_VOCAL", name: "PAGO A VOCAL" },
        { id: "SERVEL_PAGO_CAPACITADO", name: "PAGO POR CAPACITACIÓN" },
        { id: "SERVEL_PAGO_ESCRUTADOR", name: "PAGO POR ESCRUTADOR" },
      ],

      tipoDeCuentaPagos: ["CUENTA_CORRIENTE", "CUENTA_AHORRO", "CUENTA_VISTA"],

      medioPagoOptions: ["DEPOSITO", "PAGOPORCAJA"],

      tipoDeBancos: [
        { id: 1, name: "Banco de Chile" },
        { id: 9, name: "Banco Internacional" },
        { id: 14, name: "Scotiabank" },
        { id: 16, name: "Banco de crédito e Inversiones" },
        { id: 28, name: "Banco BICE" },
        { id: 31, name: "HSBC Bank Chile" },
        { id: 37, name: "Banco Santander Chile" },
        { id: 39, name: "Itaú CorpBanca" },
        { id: 49, name: "Banco Security" },
        { id: 51, name: "Banco Falabella" },
        { id: 53, name: "Banco Ripley" },
        { id: 54, name: "Rabobank Chile" },
        { id: 55, name: "Banco Consorcio" },
        { id: 56, name: "Banco Penta" },
        { id: 504, name: "Banco Bilbao Vizcaya Argentaria Chile (BBVA)" },
        { id: 59, name: "Banco BTG Pactual Chile" },
        { id: 12, name: "Banco Estado" },
        { id: 672, name: "Coopeuch" },
        { id: 729, name: "Prepago Los Heroes" },
        { id: 730, name: "Tenpo Prepago" },
        { id: 875, name: "Banco Mercadopago" },
      ],

      formPago: {
        conceptopago: "",
        dateEleccion: false,
        montopago: "",
        fechaeleccion: null,
        nombreeleccion: null,
        tipopersona: "NATURAL",

        rut: "",
        dv: "",
        nombre: "",
        apellidopaterno: "",
        apellidomaterno: "",
        correo: "",

        codigocomuna: null,
        tipocalle: "",
        calle: "",
        dirnumero: "",
        direcciondepto: "",

        monedapago: "UF",
        mediopago: "",

        bancopagosbif: null,
        tipocuentapago: null,
        numerocuentapago: "",

        codigoregistro: "",
        dvcodigoregistro: "",
        nombrecomuna: "",
        numeroregion: "",
        tipoeleccion: "",
        fechacapacitacion: "",
        dateCapacitacion: false,
        identificacionlocal: "",
        codigocircunscripcion: "",
        circunscripcionelectoral: "",
        codigomesa: "",
        evidenciaFiles: [],
        urldocumento: [],
      },
    };
  },

  computed: {
    ...mapGetters(["getPerfil"]),

    validFormBtn() {
      return (
        !!this.formPago.conceptopago &&
        !!this.formPago.nombreeleccion &&
        !!this.formPago.fechaeleccion &&
        this.formPago.rut !== "" &&
        this.formPago.dv !== "" &&
        this.formPago.apellidopaterno !== "" &&
        this.formPago.apellidomaterno !== "" &&
        this.formPago.nombre !== "" &&
        this.formPago.bancopagosbif !== null &&
        !!this.formPago.tipocuentapago &&
        !!this.formPago.numerocuentapago &&
        this.formPago.montopago !== "" &&
        !!this.formPago.monedapago
      );
    },
  },

  watch: {
    'formPago.numeroregion'(val) {
      if (this.skipRegionWatch) return;
      if (val) {
        this.cargarComunas(val);
      } else {
        this.comunasFiltradas = [];
        this.circunscripcionesFiltradas = [];
        this.formPago.nombrecomuna = null;
        this.formPago.codigocircunscripcion = null;
        this.formPago.circunscripcionelectoral = null;
      }
    },
    'formPago.nombrecomuna'(val) {
      if (this.skipComunaWatch) return;
      if (val) {
        this.autocompletarDesdeComuna(val);
        this.cargarCircunscripciones(val);
      } else {
        this.circunscripcionesFiltradas = [];
        this.formPago.codigocircunscripcion = null;
        this.formPago.circunscripcionelectoral = null;
      }
    },
  },

  mounted() {
    this.comunas = comunas.comunas;
    this.cargarGlosas();
    this.getElecciones();
  },

  methods: {
    async cargarGlosas() {
      try {
        this.glosas = await PagoVocalesService.getGlosas() || [];
        this.derivarRegiones();
        this.cargarTodasLasComunas();
        this.cargarTodasLasCircunscripciones();
      } catch (error) {
        console.log('Error al cargar glosas:', error);
        this.glosas = [];
        this.regiones = [];
        this.comunasFiltradas = [];
        this.circunscripcionesFiltradas = [];
      }
    },

    derivarRegiones() {
      const unicas = new Map();
      this.glosas.forEach((g) => {
        if (g.numeroregion && !unicas.has(g.numeroregion)) {
          unicas.set(g.numeroregion, { numeroregion: g.numeroregion, region: g.region });
        }
      });
      this.regiones = Array.from(unicas.values()).sort(
        (a, b) => Number(a.numeroregion) - Number(b.numeroregion)
      );
    },

    cargarTodasLasComunas() {
      const unicas = new Map();
      this.glosas.forEach((g) => {
        if (g.nombrecomuna && !unicas.has(g.nombrecomuna)) {
          unicas.set(g.nombrecomuna, { nombrecomuna: g.nombrecomuna });
        }
      });
      this.comunasFiltradas = Array.from(unicas.values()).sort((a, b) =>
        a.nombrecomuna.localeCompare(b.nombrecomuna)
      );
    },

    cargarTodasLasCircunscripciones() {
      const unicas = new Map();
      this.glosas.forEach((g) => {
        if (g.codigocircunscripcion && !unicas.has(g.codigocircunscripcion)) {
          unicas.set(g.codigocircunscripcion, {
            codigocircunscripcion: g.codigocircunscripcion,
            circunscripcionelectoral: g.circunscripcionelectoral,
          });
        }
      });
      this.circunscripcionesFiltradas = Array.from(unicas.values()).sort((a, b) =>
        String(a.codigocircunscripcion).localeCompare(String(b.codigocircunscripcion))
      );
    },

    cargarComunas(numeroregion) {
      const unicas = new Map();
      this.glosas
        .filter((g) => String(g.numeroregion) === String(numeroregion))
        .forEach((g) => {
          if (g.nombrecomuna && !unicas.has(g.nombrecomuna)) {
            unicas.set(g.nombrecomuna, { nombrecomuna: g.nombrecomuna });
          }
        });
      this.comunasFiltradas = Array.from(unicas.values()).sort((a, b) =>
        a.nombrecomuna.localeCompare(b.nombrecomuna)
      );
    },

    cargarCircunscripciones(nombrecomuna) {
      const unicas = new Map();
      this.glosas
        .filter((g) => g.nombrecomuna === nombrecomuna)
        .forEach((g) => {
          if (g.codigocircunscripcion && !unicas.has(g.codigocircunscripcion)) {
            unicas.set(g.codigocircunscripcion, {
              codigocircunscripcion: g.codigocircunscripcion,
              circunscripcionelectoral: g.circunscripcionelectoral,
            });
          }
        });
      this.circunscripcionesFiltradas = Array.from(unicas.values()).sort((a, b) =>
        String(a.codigocircunscripcion).localeCompare(String(b.codigocircunscripcion))
      );
    },

    autocompletarDesdeComuna(nombrecomuna) {
      this.skipRegionWatch = true;
      const glosa = this.glosas.find((g) => g.nombrecomuna === nombrecomuna);
      if (glosa && glosa.numeroregion) {
        this.formPago.numeroregion = glosa.numeroregion;
        this.cargarComunas(glosa.numeroregion);
      }
      this.skipRegionWatch = false;
    },

    onCircunscripcionChange(codigocircunscripcion) {
      if (!codigocircunscripcion) return;
      this.skipRegionWatch = true;
      this.skipComunaWatch = true;
      const glosa = this.glosas.find(
        (g) => String(g.codigocircunscripcion) === String(codigocircunscripcion)
      );
      if (glosa) {
        this.formPago.numeroregion = glosa.numeroregion;
        this.formPago.nombrecomuna = glosa.nombrecomuna;
        const circ = this.circunscripcionesFiltradas.find(
          (c) => String(c.codigocircunscripcion) === String(codigocircunscripcion)
        );
        if (circ) {
          this.formPago.circunscripcionelectoral = circ.circunscripcionelectoral;
        }
        this.cargarComunas(glosa.numeroregion);
      }
      this.skipRegionWatch = false;
      this.skipComunaWatch = false;
    },

    onCircunscripcionElectoralChange(circunscripcion) {
      if (!circunscripcion) return;
      const circ = this.circunscripcionesFiltradas.find(
        (c) => c.circunscripcionelectoral === circunscripcion
      );
      if (circ) {
        this.formPago.codigocircunscripcion = circ.codigocircunscripcion;
        this.onCircunscripcionChange(circ.codigocircunscripcion);
      }
    },

    getInitialForm() {
      return {
        conceptopago: "",
        dateEleccion: false,
        montopago: "",
        fechaeleccion: null,
        nombreeleccion: null,
        tipopersona: "NATURAL",

        rut: "",
        dv: "",
        nombre: "",
        apellidopaterno: "",
        apellidomaterno: "",
        correo: "",

        codigocomuna: null,
        tipocalle: "",
        calle: "",
        dirnumero: "",
        direcciondepto: "",

        monedapago: "UF",
        mediopago: "",

        bancopagosbif: null,
        tipocuentapago: null,
        numerocuentapago: "",

        codigoregistro: "",
        dvcodigoregistro: "",
        nombrecomuna: "",
        numeroregion: "",
        tipoeleccion: "",
        fechacapacitacion: "",
        dateCapacitacion: false,
        identificacionlocal: "",
        codigocircunscripcion: "",
        circunscripcionelectoral: "",
        codigomesa: "",
        evidenciaFiles: [],
        urldocumento: [],
      };
    },

    clearData() {
      this.formPago = this.getInitialForm();

      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },

    sanitizeFolderName(name) {
      return String(name || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-zA-Z0-9_-]/g, '_')
        .toLowerCase();
    },

    async getElecciones() {
      try {
        this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "Cargando..",
          background: "rgba(0, 0, 0, 0.8)",
        });

        this.elecciones = await PagoVocalesService.getElecciones();
      } catch (error) {
        console.log("error", error);
        Swal.fire({
          type: "error",
          html: `Error al cargar la lista de elecciones: ${error}`,
        });
      } finally {
        if (this.loadingInstance) this.loadingInstance.close();
      }
    },

    conceptoOnChange(concepto) {
      if (concepto === "SERVEL_PAGO_VOCAL" ||
        concepto === "SERVEL_PAGO_ESCRUTADOR") {
        this.formPago.montopago = "0.6667";
      } else if (
        concepto === "SERVEL_PAGO_CAPACITADO" 
      ) {
        this.formPago.montopago = "0.22";
      } else {
        this.formPago.montopago = "";
      }
    },

    mediopagoOnChange() {
      if (this.formPago.mediopago === "PAGOPORCAJA") {
        this.formPago.bancopagosbif = 1
        this.formPago.tipocuentapago = "CUENTA_VISTA"
        this.formPago.numerocuentapago = 111111111
      } 
    },

    async sendPago() {
      try {
        const esValido = this.$refs.form.validate();
        if (!esValido) return;

        this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "Cargando..",
          background: "rgba(0, 0, 0, 0.8)",
        });

        const pagoData = { ...this.formPago };

        delete pagoData.dateEleccion;
        delete pagoData.dateCapacitacion;
        delete pagoData.direcciondepto;

        pagoData.dv = pagoData.dv ? String(pagoData.dv).trim().toUpperCase() : null;
        pagoData.rut = pagoData.rut !== "" ? Number(pagoData.rut) : null;
        pagoData.bancopagosbif = pagoData.bancopagosbif !== null ? Number(pagoData.bancopagosbif) : null;
        pagoData.numerocuentapago = pagoData.numerocuentapago ? String(pagoData.numerocuentapago).trim() : null;
        pagoData.montopago = pagoData.montopago !== "" ? Number(pagoData.montopago) : null;
        pagoData.numeroregion = pagoData.numeroregion !== null && pagoData.numeroregion !== undefined && String(pagoData.numeroregion).trim() !== ""
          ? String(pagoData.numeroregion).trim()
          : null;

        Object.keys(pagoData).forEach((key) => {
          if (typeof pagoData[key] === "string") {
            pagoData[key] = pagoData[key].trim();
            if (pagoData[key] === "") {
              pagoData[key] = null;
            }
          }
        });

        delete pagoData.evidenciaFiles;
        pagoData.urldocumento = [];

        if (this.formPago.evidenciaFiles && this.formPago.evidenciaFiles.length > 0) {
          try {
            pagoData.urldocumento = await this.uploadEvidencias(this.loadingInstance, pagoData);
          } catch (err) {
            return;
          }
        }

        this.loadingInstance.setText("Enviando pago...");

        const payloadData = {
          data: pagoData,
          idusuario: this.getPerfil.id,
          direccionregionalid: this.getPerfil.direccion_regional_id
        };

        const resp = await PagoVocalesService.crear(payloadData);

        if (resp.statusCode !== 200 && resp.statusCode !== 201) {
          throw resp.msg || resp;
        }

        this.clearData();

        Swal.fire({
          type: "success",
          html: "Pago enviado",
        });
      } catch (error) {
        console.log("error", error);

        Swal.fire({
          type: "error",
          html: `Error al enviar el pago: ${typeof error === "string" ? error : JSON.stringify(error)}`,
        });
      } finally {
        if (this.loadingInstance) this.loadingInstance.close();
      }
    },

    async uploadEvidencias(loadingInstance, pagoData) {
      const files = this.formPago.evidenciaFiles;
      if (!files || !files.length) return [];

      const uploaded = [];
      const totalFiles = files.length;
      this.uploadingEvidencia = true;

      try {
        for (let i = 0; i < totalFiles; i++) {
          const file = files[i];
          const fileNumber = i + 1;

          if (loadingInstance) {
            loadingInstance.setText(`Obteniendo acceso para evidencia ${fileNumber} de ${totalFiles}...`);
          }

          const resp = await PagoVocalesService.cargarEvidencia({
            filename: file.name,
            filetype: file.type || 'application/octet-stream',
            nombreeleccion: this.sanitizeFolderName(pagoData.nombreeleccion),
            rut: pagoData.rut
          });

          const bodyData = typeof resp.body === 'string' ? JSON.parse(resp.body) : resp.body;
          if (!bodyData || !bodyData.uploadURL || !bodyData.fileUrl) {
            throw new Error('Respuesta de carga de evidencia inválida');
          }

          if (loadingInstance) {
            loadingInstance.setText(`Subiendo evidencia ${fileNumber} de ${totalFiles}: 0%`);
          }

          await axios.put(bodyData.uploadURL, file, {
            headers: { 'Content-Type': file.type || 'application/octet-stream' },
            onUploadProgress: (progressEvent) => {
              if (!loadingInstance) return;
              const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              loadingInstance.setText(`Subiendo evidencia ${fileNumber} de ${totalFiles}: ${percentCompleted}%`);
            }
          });

          uploaded.push(bodyData.fileUrl);
        }

        this.formPago.evidenciaFiles = [];
        return uploaded;
      } catch (err) {
        console.error('Error subiendo evidencia:', err);
        Swal.fire({
          type: 'error',
          html: `Error al subir evidencia: ${err.message || JSON.stringify(err)}`
        });
        throw err;
      } finally {
        this.uploadingEvidencia = false;
      }
    },
  }
};
</script>

<style scoped>
.container {
  text-align: start !important;
}
</style>